export async function handleLogout() {
	/**
	 * Session token expired, so clear the local storage
	 * and redirect the user to login page
	 */
	const token = localStorage.getItem('fcm_token');
	if (token) {
		try {
			// Dynamically import store and removeFcmToken to avoid circular deps
			const { store } = await import('../store');
			const { removeFcmToken } = await import('../store/pageSlice');
			await store.dispatch(removeFcmToken({ data: { device_token: token } }));
		} catch (e) {
			console.debug('Failed to remove FCM token from backend', e);
		}
		localStorage.removeItem('fcm_token');
	}
	localStorage.clear();
	try {
		sessionStorage.clear();
	} catch (e) {
		console.debug('Failed to clear sessionStorage on logout', e);
	}
	window.location = `${window.origin}/login`;
}

export function setLocalData(UserData) {
	localStorage.setItem(process.env.REACT_APP_VTS_APP_TOKEN, JSON.stringify(UserData));
}

export function setUserType(data) {
	localStorage.setItem('user_type', JSON.stringify(data));
}
